<template>
  <div class="card">
    <div class="card-header bg-dark">
      <h3 class="mb-0 text-white">บันทึกกิจกรรม</h3>
    </div>

    <el-table
      row-key="id"
      header-row-class-name="thead-light"
      :data="queriedData"
    >
      <el-table-column label="รายละเอียด" min-width="200px">
        <div slot-scope="{ row }">
          {{ row.Description }}
        </div>
      </el-table-column>
      <el-table-column label="ผู้ดำเนินการ" min-width="100px">
        <div slot-scope="{ row }">
          {{ row.Operator }}
        </div>
      </el-table-column>
      <el-table-column label="IP" min-width="100px">
        <div slot-scope="{ row }">
          {{ row.IPAddress }}
        </div>
      </el-table-column>
      <el-table-column label="วันที่/เวลา" min-width="100px">
        <div slot-scope="{ row }">
          {{ row.CreatedAt | moment("DD/MM/YYYY HH:mm") }}
        </div>
      </el-table-column>
    </el-table>

    <div class="card-footer border-0 d-flex justify-content-between">
      <p class="card-category">
        Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
      </p>

      <base-pagination
        :per-page="pagination.perPage"
        :total="total"
        v-model="pagination.currentPage"
      />
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "../../components";

import moment from "moment";
import BonusService from "../../services/bonus.service";
import tablePagination from "../../mixins/tablePagination";

export default {
  props: ["data", "count", "_searchQuery"],
  mixins: [
    tablePagination(["Description", "Operator", "IPAddress", "CreatedAt"], 25),
  ],
  components: {
    BasePagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  created() {
    console.log(this.data);
    this.updateTableData(this.data);
  },
  watch: {
    data(v) {
      this.updateTableData(v);
    },
    _searchQuery(v) {
      this.searchQuery = v;
    },
  },
};
</script>
